module.exports = dibs_vendor_buyer;